<template>
  <div class="funnel">
    <div style="color: #1E3959!important;" class="funnel__title">
      Воронка кандидатов
    </div>

    <div class="funnel__description">
      Учитываются данные только закрытых вакансий
    </div>

    <VDataTable
        v-if="props.items?.length > 0"
        :key="sortBy + sortDesc"
        :headers="props.headers"
        :items="itemsSorted"
        v-model="selected"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        :pagination="false"
        height-row="60"
        @update:sort-by="sortBy = $event"
        @update:sort-desc="sortDesc = $event"
        maxHeight="472px"
    >
      <template #item.title="{item}">
        <p style="font-size: 14px" class="title h-full flex vertical-center" v-if="item.title">{{ item.title }}</p>
        <div v-else>-</div>
      </template>
      <template #item.total="{item}">
        <p class="title" v-if="item.total"><AnalyticsWrapperTable :items="item.total" /></p>
        <div v-else>-</div>
      </template>
      <template #item.resume="{item}">
        <p class="title" v-if="item.resume"><AnalyticsWrapperTable :items="item.resume" /></p>
        <div v-else>-</div>
      </template>
      <template #item.documents="{item}">
        <p class="title" v-if="item.documents"><AnalyticsWrapperTable :items="item.documents" /></p>
        <div v-else>-</div>
      </template>
      <template #item.medical_check="{item}">
        <p class="title" v-if="item.medical_check"><AnalyticsWrapperTable :items="item.medical_check" /></p>
        <div v-else>-</div>
      </template>
      <template #item.tickets="{item}">
        <p class="title" v-if="item.tickets"><AnalyticsWrapperTable :items="item.tickets" /></p>
        <div v-else>-</div>
      </template>
      <template #item.accepted="{item}">
        <p class="title" v-if="item.accepted"><AnalyticsWrapperTable :items="item.accepted" /></p>
        <div v-else>-</div>
      </template>
      <template #item.conversion="{item}">
        <p class="bold title" style="font-size: 14px" v-if="item?.accepted">{{ formatNum(item?.accepted?.share) }}%</p>
        <p  :style="getColor(item?.accepted?.delta_percent)" style="font-size: 14px" v-if="item?.accepted">{{ formatNum(item?.accepted?.delta_percent) }}%</p>
        <div v-else>-</div>
      </template>
    </VDataTable>


    <div v-if="props.items?.length > 0" class="funnel__total">
      <div class="title-total">Итого</div>
      <p class="item-total" v-if="total.total"><AnalyticsWrapperTable :items="total.total" /></p>
      <p class="item-total" v-if="total.resume"><AnalyticsWrapperTable :items="total.resume" /></p>
      <p class="item-total" v-if="total.documents"><AnalyticsWrapperTable :items="total.documents" /></p>
      <p class="item-total" v-if="total.medical_check"><AnalyticsWrapperTable :items="total.medical_check" /></p>
      <p class="item-total" v-if="total.tickets"><AnalyticsWrapperTable :items="total.tickets" /></p>
      <p class="item-total" v-if="total.accepted"><AnalyticsWrapperTable :items="total.accepted" /></p>
      <div class="item-total">
        <p class="bold title" style="font-size: 14px" v-if="total?.accepted">{{ formatNum(total?.accepted?.share) }}%</p>
        <p  :style="getColor(total?.accepted?.delta_percent)" style="font-size: 14px" v-if="total?.accepted">{{ formatNum(total?.accepted?.delta_percent) }}%</p>
        <div v-else>-</div>
      </div>


    </div>
    <div class="no-data" v-else>
      Нет данных
    </div>
  </div>
</template>
<script setup>
import {computed, ref} from "vue";
import {useRoute} from "vue-router";
import AnalyticsWrapperTable from "@/components/Analytics/wrapper-table.vue";
import {formatNum, getColor} from "@/utils";
import {SORT_CONFIG_FUNNEL} from "@/constants";

const props = defineProps({
  items: [Object, Array],
  headers: [Object, Array],
  total: [Object, Array],
})
const route = useRoute();

const isVacancy = computed(() => {
  return route.query?.tabs === 'vacancy'
});


function declineDays(count) {
  let number
  if (typeof count === 'string') {
    number = parseInt(count)
  } else {
    number = count
  }
  const cases = [2, 0, 1, 1, 1, 2]; // варианты склонения
  const titles = ['день', 'дня', 'дней'];

  // Определяем нужную форму слова
  const index =
      (number % 100 > 4 && number % 100 < 20)
          ? 2
          : cases[(number % 10 < 5) ? number % 10 : 5];

  return `${titles[index]}`;
}

const formatNumber = (num) => {
  // Преобразуем в число, если передана строка
  const number = typeof num === 'string' ? parseFloat(num.replace(/\s+/g, '')) : num;

  // Проверяем, что это действительное число
  if (isNaN(number)) return num.toString();

  // Форматируем с разделителями
  return number.toLocaleString('ru-RU', {
    maximumFractionDigits: 20 // Чтобы не округляло десятичные дроби
  }).replace(/,/g, ' '); // Заменяем запятые на пробелы (по русскому стандарту)
}

const selected = ref([])
const sortBy = ref('title')
const sortDesc = ref(false)

const itemsSorted = computed(() => {
  if (!sortBy.value || sortDesc.value === 'none') {
    return props.items
  }

  const config = SORT_CONFIG_FUNNEL[sortBy.value]
  if (!config) {
    console.warn(`Unknown sort field: ${sortBy.value}`)
    return props.items
  }

  return [...props.items].sort((a, b) => {
    let valueA, valueB

    if (config.type === 'string') {
      valueA = a[config.field].toLowerCase()
      valueB = b[config.field].toLowerCase()
    } else {
      // Для вложенных объектов разбиваем путь к полю
      const fields = config.field.split('.')
      valueA = fields.reduce((obj, field) => obj[field], a)
      valueB = fields.reduce((obj, field) => obj[field], b)
    }

    if (valueA < valueB) {
      return sortDesc.value ? 1 : -1
    }
    if (valueA > valueB) {
      return sortDesc.value ? -1 : 1
    }
    return 0
  })
})
</script>
<style lang="scss" scoped>
.funnel {
  background-color: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 76px;

  &__title {
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 8px;
    color: $dark-blue;
  }

  &__description {
    font-size: 14px;
    margin-bottom: 20px;
    color: $dark-blue;
  }

  &__total {
    display: flex;
    font-size: 14px;
    padding: 12px 24px;
    background-color: $light;
    border: 1px solid $grey-main;
    border-radius: 16px;
    margin-top: 12px;
    gap: 45px;
    align-items: center;


    .title-total {
      width: 133px;
      font-weight: 500;
      font-size: 14px;
    }

    .item-total {
      width: 80px;
      //font-weight: 600;
      font-size: 14px;
    }

    .conversy-total {
      width: 150px;
      display: flex;
      font-size: 12px;
      align-items: center;
    }
  }

  &__total-closed {
    display: flex;
    font-size: 14px;
    padding: 12px 24px;
    background-color: $light;
    border: 1px solid $grey-main;
    border-radius: 16px;
    margin-top: 12px;


    .title {
      width: 508px;
      font-weight: 500;
      font-size: 14px;
    }

    .time {
      width: 187px;
      font-weight: 600;
      font-size: 14px;
    }

    .conversy {
      width: 190px;
      display: flex;
      font-size: 12px;
      align-items: center;
    }

    .closed {

      width: 50px;
      display: flex;
      font-size: 12px;
      align-items: center;
    }
  }

  .conversy {
    display: flex;
    font-size: 12px;
    align-items: center;
  }


  .time {
    font-weight: 600;
    font-size: 14px;
  }

  .text-b {
    font-weight: 600;
    font-size: 14px !important;
  }
  .no-data {
    height: 326px;
    width: 100%;
    color: $gray;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 20px;
    text-align: center;
    border: 1px solid rgba(228, 231, 238, 1);
    border-radius: 12px;
  }
}
</style>